import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import colors, { WHITE, GRAY_SUIT, PORCELAIN, MAIN_BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const AutocompleteWrapper = styled.div`
  .multi-select-search,
  &.multi-select-search {
    position: relative;

    .MuiAutocomplete-popper {
      top: calc(100% - 4px);

      .MuiAutocomplete-listbox {
        max-height: 200px;
        padding: 4px 0;

        ${breakpoints.down('sm')} {
          max-height: 166px;
        }
      }
    }

    .Mui-focused {
      .MuiInputBase-root {
        border-color: transparent;
        box-shadow: 0 4px 16px rgba(42, 42, 53, 0.1);
      }
    }

    &__input {
      .MuiInputBase-input {
        font-size: 17px;
        font-weight: 500;
        line-height: 30px;
      }

      .MuiInputBase-root {
        background-color: ${WHITE};
        border: 1px solid ${GRAY_SUIT};
        padding: 4.5px 12px 4.5px 8px;
      }

      .Mui-disabled {
        *,
        ::placeholder {
          color: ${p => p.theme.palette.text.disabled} !important;
        }
      }
    }

    &__input-adornment {
      font-size: 24px;

      &--open {
        .multi-select-search__chevron {
          transform: rotate(-180deg);
        }
      }
    }

    &__option {
    }
  }

  .MuiAutocomplete-option {
    padding: 0;

    &[aria-selected='true'] {
      color: inherit;
    }

    &[aria-selected='true']:not([data-focus='true']) {
      background-color: transparent;
    }
  }
`;

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px 16px 64px;
  white-space: normal;
  word-break: break-word;
  background-color: ${p =>
    p.selected ? rgba(p.theme.palette.primary.main || colors.primary, 0.05) : WHITE};
  color: ${p => (p.selected ? p.theme.palette.primary.main : 'inherit')};
  font-weight: ${p => (p.have ? '700' : '400')};
  width: 100%;
  position: relative;
  min-height: 80px;
  z-index: 1;

  > *:not(button) {
    pointer-events: none;
  }

  &.list-item {
    &--disabled {
      opacity: 0.5;
      background-color: ${PORCELAIN};
      cursor: default;
    }
  }

  .list-item {
    &__icon {
      font-size: 24px;
      position: absolute;
      top: 50%;
      left: 32px;
      transform: translate(-50%, -50%);
    }

    &__info {
      width: 33.33%;
    }

    &__price {
      color: ${MAIN_BLACK};
    }

    &__dummy-channels-count {
      width: 72px;
    }

    &__dummy-btn {
      width: 129px;
    }
  }

  ${breakpoints.down('xs')} {
    display: block;

    .list-item {
      &__icon {
        top: 28px;
      }

      &__title {
        margin-bottom: 5px;
      }

      &__info {
        width: 100%;
      }

      &__btn {
        margin-top: 10px;
        width: 100%;
      }
    }
  }
`;

export const NoResults = styled.div`
  color: ${p => p.theme.palette.text.primary};
  cursor: default;
  overflow: hidden;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.4rem;
`;

export default AutocompleteWrapper;
